import { motion } from "framer-motion";
import { PAIN_POINTS, SCROLL_REVEAL } from "@/lib/content";

export const PainPoints = () => {
  return (
    <section
      id="pain"
      data-testid="pain-points-section"
      className="relative bg-ink py-10 sm:py-14"
    >
      <div className="container px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto">
        <motion.div {...SCROLL_REVEAL} className="text-center">
          <p className="font-serif-tc text-[18px] sm:text-2xl leading-relaxed text-[hsl(var(--foreground))]/80">
            若以下有 <span className="lime-keyword font-bold">2 項以上</span> 與你相符 — 這場為你而設
          </p>
        </motion.div>

        <motion.div {...SCROLL_REVEAL} className="mt-6 sm:mt-8 flex flex-wrap items-center justify-center gap-2 sm:gap-2.5">
          {PAIN_POINTS.map((p, i) => (
            <motion.span
              key={i}
              initial={{ opacity: 0, y: 6 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.3, delay: i * 0.04 }}
              data-testid={`pain-point-${i}`}
              className="inline-flex items-center gap-1.5 text-[12px] sm:text-[13px] px-3 py-1.5 rounded-full border border-[rgba(255,255,255,0.12)] bg-[rgba(255,255,255,0.02)] text-[hsl(var(--foreground))]/85 hover:border-[rgba(212, 180, 106,0.4)] hover:text-[hsl(var(--lime))] transition-colors"
            >
              <span className="w-1 h-1 rounded-full bg-[hsl(var(--lime))]" />
              {p}
            </motion.span>
          ))}
        </motion.div>
      </div>
    </section>
  );
};
